import React from "react";
import TextField from "@material-ui/core/TextField";
import Select from "@material-ui/core/Select";
import Button from "@material-ui/core/Button";
import * as yup from "yup";
import { Formik, Form, useFormik } from "formik";
import { SnackbarActionTypes } from "../../redux/snackbar/snackbar.types";
import useStyles from "./CompanyHeaderDetails.style";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { useSelector, useDispatch } from "react-redux";
import { getUser } from "../../helpers/services/UserServices";
import {updateCompany} from "../../helpers/services/CompanyServices"
import CircularProgress from "@material-ui/core/CircularProgress";
import { useHistory } from "react-router-dom";
import {
  retrieveCompanyAppendices,
  retrieveCompanySubsidiaries,
  selectCompany,
} from "../../redux/company/company.actions";

const CompanyHeaderDetails = (props) => {
  const history = useHistory();
  const { selectedCompany } = useSelector((state) => state.company);
  const styles = useStyles();
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const loading = open && options.length === 0;

  const handleInputChange = (event, value) => {
    if (value.length > 3) {
      getUserName(value);
    }
  };

  const getUserName = async (data) => {
    try {
      let result = await getUser(data);
      console.log("result", result);
      setOptions(result);
    } catch (error) {
      console.log(error);
    }
  };

  React.useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  let validation = yup.object().shape({
    name: yup.string().required("Dieses Feld ist notwendig"),
    vat_id: yup.string().required("Dieses Feld ist notwendig"),
    customer_no: yup.string().required("Dieses Feld ist notwendig"),
    trader_contact_first_name: yup.string().required("Dieses Feld ist notwendig"),
    trader_contact_last_name: yup.string().required("Dieses Feld ist notwendig"),
    trader_contact_phone: yup
      .string()
      .matches(
        /^\+49\d{10,16}$/gm,
        "Ungültige Telefonnummer. Bitte Format +491234567890 verwenden"
      )
      .required("Dieses Feld ist notwendig"),
    trader_contact_email: yup
      .string()
      .email("Bitte geben Sie ein korrektes E-Mailformat an")
      .required("Dieses Feld ist notwendig"),
  });

  let formik = useFormik({
    initialValues: selectedCompany,
    validationSchema: validation,
    onSubmit: (values) => {
      handleSubmit(values);
      
    },
  });

  const handleSubmit = async (val) => {
    console.log(val);
    let result = await updateCompany(val);
    dispatch({ type: SnackbarActionTypes.SHOW_SNACKBAR, payload : {message:"Gespeichert"} });
    if(result.id)
      dispatch(selectCompany({...val,...result,addresses:[]}));
    formik.setSubmitting(false);
    
  };  
  return (
    <div className={styles.mainContainer}>
      <div className={styles.flex}>
        <div className={styles.flexPrimary}>
          <div
            style={{
              color: "#1F6E5E",
              marginLeft: 10,
              fontSize: 20,
              fontWeight: 600,
              letterSpacing: "0.1rem",
            }}
          >
            {selectedCompany.name}
          </div>
        </div>
      </div>

      <form onSubmit={formik.handleSubmit}>
        <div className={styles.form_container}>
          <div className={styles.form}>
          <div className={styles.formSectionTitle}>Fachhändler</div>  
          <div className={styles.text_container}>
              <div style={{ width: "65%", paddingTop: 10 }}>
                Name:
              </div>
              <TextField
                error={formik.errors.name && formik.touched.name}
                className={styles.textField}
                value={formik.values.name}
                fullWidth
                onChange={formik.handleChange}
                id="name"
                name="name"
                autoFocus
                helperText={
                  formik.errors.name && formik.touched.name
                    ? formik.errors.name
                    : null
                }
                size="small"
              />
            </div>

            <div className={styles.text_container}>
              <div style={{ width: "65%", paddingTop: 24 }}>Umsatzsteuernummer :</div>
              <TextField
                id="vat_id"
                onChange={formik.handleChange}
                className={styles.textField}
                value={formik.values.vat_id}
                error={formik.errors.vat_id && formik.touched.vat_id}
                helperText={
                  formik.errors.vat_id && formik.touched.vat_id
                    ? formik.errors.vat_id
                    : null
                }
                margin="normal"
                size="small"
              />
            </div>
            <div className={styles.text_container}>
              <div style={{ width: "65%", paddingTop: 24 }}>Handelsregisternummer :</div>
              <TextField
                id="register_no"
                onChange={formik.handleChange}
                className={styles.textField}
                value={formik.values.register_no}
                error={formik.errors.register_no && formik.touched.register_no}
                helperText={
                  formik.errors.register_no && formik.touched.register_no
                    ? formik.errors.register_no
                    : null
                }
                margin="normal"
                size="small"
              />
            </div>
            <div className={styles.text_container}>
              <div style={{ width: "65%", paddingTop: 24 }}>Kundennummer :</div>
              <TextField
                id="customer_no"
                className={styles.textField}
                value={formik.values.customer_no}
                onChange={formik.handleChange}
                error={formik.errors.customer_no && formik.touched.customer_no}
                helperText={
                  formik.errors.customer_no && formik.touched.customer_no
                    ? formik.errors.customer_no
                    : null
                }
                margin="normal"
                size="small"
              />
            </div>
          </div>
          <div className={styles.form}>
          <div className={styles.formSectionTitle}>Fachhändler Ansprechpartner</div>  
          <div className={styles.text_container}>
          <div style={{ width: "65%", paddingTop: 10 }}>
          Anrede :
          </div>
          <Select
            style={{paddingTop: "3%" }}
            id="trader_contact_gender"
            name="trader_contact_gender"
            fullWidth
            className={styles.textField}
            defaultValue= {formik.values.trader_contact_gender}
            value={formik.values.trader_contact_gender}
            onChange={formik.handleChange}
            helperText={
              formik.touched.trader_contact_gender
                ? formik.errors.trader_contact_gender
                : ""
            }
            error={
              formik.touched.trader_contact_gender &&
              Boolean(formik.errors.trader_contact_gender)
            }
            size="small"
          >
            <option value={"Herr"}>Herr</option>
            <option value={"Frau"}>Frau</option>
          </Select>
        </div>
        
            <div className={styles.text_container}>
              <div style={{ width: "65%", paddingTop: 10 }}>
              Vorname :
              </div>
              <TextField
                id="trader_contact_first_name"
                fullWidth
                className={styles.textField}
                value={formik.values.trader_contact_first_name}
                onChange={formik.handleChange}
                helperText={
                  formik.touched.trader_contact_first_name
                    ? formik.errors.trader_contact_first_name
                    : ""
                }
                error={
                  formik.touched.trader_contact_first_name &&
                  Boolean(formik.errors.trader_contact_first_name)
                }
                size="small"
              />
            </div>
            <div className={styles.text_container}>
              <div style={{ width: "65%", paddingTop: 24 }}>
              Nachname :
              </div>
              <TextField
                id="trader_contact_last_name"
                className={styles.textField}
                value={formik.values.trader_contact_last_name}
                onChange={formik.handleChange}
                helperText={
                  formik.touched.trader_contact_last_name
                    ? formik.errors.trader_contact_last_name
                    : ""
                }
                error={
                  formik.touched.trader_contact_last_name &&
                  Boolean(formik.errors.trader_contact_last_name)
                }
                margin="normal"
                size="small"
              />
            </div>
            <div className={styles.text_container}>
              <div style={{ width: "65%", paddingTop: 26 }}>
                E-Mail :
              </div>
              <TextField
                id="trader_contact_email"
                value={formik.values.trader_contact_email}
                className={styles.textField}
                onChange={formik.handleChange}
                helperText={
                  formik.touched.trader_contact_email
                    ? formik.errors.trader_contact_email
                    : ""
                }
                error={
                  formik.touched.trader_contact_email &&
                  Boolean(formik.errors.trader_contact_email)
                }
                margin="normal"
                size="small"
              />
            </div>
            <div className={styles.text_container}>
              <div style={{ width: "65%", paddingTop: 25 }}>
                Phone :
              </div>
              <TextField
                id="trader_contact_phone"
                value={formik.values.trader_contact_phone}
                className={styles.textField}
                onChange={formik.handleChange}
                helperText={
                  formik.touched.trader_contact_phone
                    ? formik.errors.trader_contact_phone
                    : ""
                }
                error={
                  formik.touched.trader_contact_phone &&
                  Boolean(formik.errors.trader_contact_phone)
                }
                margin="normal"
                size="small"
              />
            </div>
          </div>
        </div>
        <div className={styles.root}>
          <Button
            type="submit"
            disabled={formik.isSubmitting}
            variant="outlined"
            color="primary"
          >
            Speichern
          </Button>
          <Button
            // onClick={handleReset}
             onClick={() => history.push("/companies")}
            disabled={!formik.dirty || formik.isSubmitting}
            variant="outlined"
            color="secondary"
          >
            Abbrechen
          </Button>
        </div>
      </form>
    </div>
  );
};
export default CompanyHeaderDetails;
